/* global Splide */
"use strict";

($dt => {

	$dt.blocks['three-four-col-cta'] = {

		/**
		 * This is called for each block matching this type
		 * @param {HTMLElement} container 
		 */
		LoadBlock: container => {
			const slider = container.querySelector('.splide');
			const numCols = container.querySelectorAll('.single-column').length;
			let options = '';
			if (numCols === 3) {
				options = {
					type: 'loop',
					autoplay: false,
					gap: '10px',
					pagination: false,
					drag: false,
					breakpoints: {
						4000: {
							arrows: false,
							drag: false,
							perPage: 3
						},
						1200: {
							arrow: true,
							perPage: 2,
							drag: true
						},
						767: {
							perPage: 1,
							arrows: true,
							drag: true
						},
					}
				};
			} else {
				options = {
					type: 'loop',
					autoplay: false,
					gap: '10px',
					pagination: false,
					drag: false,
					breakpoints: {
						4000: {
							arrows: false,
							drag: false,
							perPage: 4
						},
						1200: {
							arrow: true,
							perPage: 2,
							drag: true
						},
						767: {
							perPage: 1,
							arrows: true,
							drag: true
						},
					}
				};
			}
			new Splide(slider, options).mount();
			//console.log(splide);
		}

	};

})(window.d3_wp_themejs);
